import component from './index.vue'
let plugin = {}
plugin.install = (Vue) => {
	// 生成一个Vue的子类
	// 同时这个子类也就是组件
	const Constructor = Vue.extend(component)
	// 生成一个该子类的实例
	const instance = new Constructor();

	// 将这个实例挂载在我创建的div上
	// 并将此div加入全局挂载点内部
	instance.$mount(document.createElement('div'))

	Vue.prototype['$'+component.name] = instance
}
export default plugin
